 export const validate = values => {
 
  const errors = {}
  if (!values.brand) {
    errors.brand = 'Required';
  }

  return errors
}